module.exports = __webpack_public_path__ + "img/logo-shadow.7d4c0192.png";